<template>
  <v-snackbar
    v-model="snackbar"
    :color="color"
    :multi-line="mode === 'multi-line'"
    :timeout="timeout"
    :vertical="mode === 'vertical'"
    right
    bottom
  >
    {{ text }}
    <template v-slot:action="{ attrs }">
      <v-btn text v-bind="attrs" @click="snackbar = false"> Close </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
import { busEvent } from '../../main';

export default {
  data() {
    return {
      snackbar: false,
      timeout: 5000,
      color: '',
      mode: '',
      text: '',
    };
  },
  created() {
    busEvent.$on('errorPopupCreated', (data) => {
      this.snackbar = true;
      this.text = data;
      this.color = 'error';
    });

    busEvent.$on('succesPopupCreated', (data) => {
      this.snackbar = true;
      this.text = data;
      this.color = 'success';
    });
  },
  methods: {},
};
</script>
